import { useQuery } from "@tanstack/react-query";
import { getDoc, doc } from "firebase/firestore";
import { db } from "@/Utils/firebase";
import type { ScanCustomerInfo, ScanGarmentMeasures } from "@/types/interfaces";

export type ScanDocData = {
  clientIds: string[];
  isPublic: boolean | undefined;
  email: string;
  gender: string;
  /** Stored in INCHES by ScanModel.create (`convertToInches`), not cm. */
  height: number;
  name: string;
  pipelineStatus: string;
  storagePath: string;
  timestamp: number;
  userId: string;
  /** Written by ScanModel.create; null when the user left it blank. */
  age?: number | null;
  /** Written by ScanModel.create; null when the user left it blank. */
  weight?: number | null;
  /** Sisley customer-entered extras. Absent on every non-Sisley scan. */
  customerInfo?: ScanCustomerInfo;
  /** Server-computed garment measures. Absent until the backend writes them. */
  garmentMeasures?: ScanGarmentMeasures;
};

const getScan = async (scanId: string): Promise<ScanDocData | null> => {
  const scanRef = doc(db, "scans", scanId);
  const scan = await getDoc(scanRef);
  return scan.exists() ? (scan.data() as ScanDocData) : null;
};

export const useScanData = (scanId: string) => {
  return useQuery({
    queryKey: ["scanData", scanId],
    queryFn: () => getScan(scanId),
  });
};
